import * as React from 'react';
import './styles/fonts/font.css';
import './styles/forms.css';
import './styles/index.css';
import '@babel/polyfill';
import 'custom-event-polyfill';
import * as serviceWorker from './serviceWorker';
import App from './App';
import ReactDOM from 'react-dom';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
